import ATableAccess from "./aTableAccess";

class WorkplaceAccess extends ATableAccess {}

export default WorkplaceAccess;
